import request from '../service/request.ts';


export const TemplateAPI = {
  selectWriteSignatureRecord: (data) =>
    request.get(`/signature/selectWriteSignatureRecord`, { params: data }),


  batchESignature: (data) =>
    request.post("/signature/batchESignature", data),

  

  
  
};

